import React, { useState, useEffect } from 'react';

const WhatsAppButton = () => {
  const [phoneNumber, setPhoneNumber] = useState('905321234567'); // Varsayılan telefon numarası
  const message = 'Merhaba, Serpil Şahin Koleji hakkında bilgi almak istiyorum.';

  useEffect(() => {
    fetchContactInfos();
  }, []);

  const fetchContactInfos = async () => {
    try {
      const response = await fetch('http://localhost/api/pages.php?type=contact', {
        credentials: 'include',
      });
      if (response.ok) {
        const text = await response.text();
        const data = text ? JSON.parse(text) : [];
        const phoneInfo = Array.isArray(data) ? data.find(info => info.type === 'phone') : null;
        if (phoneInfo && phoneInfo.content) {
          // Telefon numarasından özel karakterleri temizle
          const cleanedPhone = phoneInfo.content.replace(/[^\d+]/g, '');
          setPhoneNumber(cleanedPhone);
        }
      }
    } catch (error) {
      console.error('Error fetching contact infos:', error);
    }
  };
  
  const handleClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center group">
      {/* Hover Text */}
      <span className="mr-3 px-4 py-2 bg-[#25D366] text-white text-sm font-semibold rounded-full shadow-lg opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300 whitespace-nowrap pointer-events-none">
        Bize mesaj gönderin
      </span>
      
      {/* Button */}
      <button
        onClick={handleClick}
        className="w-14 h-14 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 relative"
        aria-label="WhatsApp ile iletişime geç"
        title="WhatsApp ile bize ulaşın"
      >
        {/* WhatsApp Logo SVG */}
        <svg 
          viewBox="0 0 32 32" 
          className="w-8 h-8 fill-white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.923 0-7.435 6.050-13.485 13.485-13.485s13.485 6.050 13.485 13.485c0 7.436-6.050 13.486-13.485 13.486zM21.960 18.828c-0.305-0.153-1.802-0.890-2.082-0.992s-0.483-0.153-0.686 0.153c-0.203 0.305-0.788 0.992-0.966 1.195s-0.356 0.229-0.661 0.076c-0.305-0.153-1.288-0.475-2.454-1.513-0.908-0.809-1.521-1.809-1.699-2.114s-0.018-0.470 0.134-0.622c0.137-0.137 0.305-0.356 0.458-0.534s0.203-0.305 0.305-0.509c0.102-0.203 0.051-0.381-0.025-0.534s-0.686-1.653-0.940-2.260c-0.248-0.593-0.499-0.513-0.686-0.522-0.178-0.008-0.381-0.010-0.584-0.010s-0.534 0.076-0.813 0.381c-0.280 0.305-1.067 1.043-1.067 2.541s1.093 2.948 1.245 3.152c0.153 0.203 2.146 3.276 5.197 4.594 0.726 0.313 1.293 0.500 1.734 0.640 0.729 0.232 1.393 0.199 1.918 0.121 0.585-0.087 1.802-0.737 2.057-1.449s0.255-1.321 0.178-1.449c-0.076-0.127-0.280-0.203-0.585-0.356z"/>
        </svg>
        
        {/* Pulse animasyonu için */}
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-75 animate-ping"></span>
      </button>
    </div>
  );
};

export default WhatsAppButton;

